var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "url" }, [
        _c("iframe", {
          attrs: {
            src: "https://kdocs.cn/l/crSmWQtn3YhC[金山文档] 五域创客系统更新日志.docx",
            width: "100%",
            height: "100%",
            id: "iframe",
          },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }